<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s37xfn/tc-custom/9781473814967.jpg?1718184630201" alt="This image is the cover for the book Historical Dreadnoughts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Historical Dreadnoughts
      </h1>
      <p class="bookDescription body article font2">
        <b>An account of Arthur Marder, his famous sparring partner Captain Stephen Roskill, and their enduring quest for pre-eminence in the naval history field. </b><br/><br/>This is the story of the remarkable, intersecting careers of the two greatest writers on British naval history in the twentieth century—the American professor Arthur Marder, son of immigrant Russian Jews, and Captain Stephen Roskill, who knew the Royal Navy from the inside. Between them, these contrasting characters were to peel back the lid of historical secrecy that surrounded the maritime aspects of the two world wars, based on the privileged access to official papers they both achieved through different channels.<br/><br/>Initially their mutual interests led to a degree of friendly rivalry, but this was to deteriorate into a stormy academic feud fought out in newspaper columns and the footnotes of their books—much to the bemusement (and sometimes amusement) of the naval history community. Out of it, surprisingly, emerged some of the best historical writing on naval themes, and a central contribution of this book is to reveal the process by which the two historians produced their literary masterpieces.<br/><br/>Anyone who has read Marder’s <i>From the Dreadnought to Scapa Flow</i> or Roskill’s <i>The War at Sea</i>—and they were both bestsellers in their day—will be entertained and enlightened by this story of the men A. J. P. Taylor called “our historical dreadnoughts.”<br/><br/><b>“A book about naval historians and their differing approaches to writing history might be dry and dull, but in the author’s capable hands makes a fascinating read.” —</b>Warship 2012
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barry Gough
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Seaforth Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b16a77d